module.exports = {
          srcSet: "/_next/static/images/facebook_logo_white-25-d7634bc048e3ec1ed7e4fa40a6026fc7.png"+" 25w",
          images:[ {path: "/_next/static/images/facebook_logo_white-25-d7634bc048e3ec1ed7e4fa40a6026fc7.png",width: 25,height: 25}],
          src: "/_next/static/images/facebook_logo_white-25-d7634bc048e3ec1ed7e4fa40a6026fc7.png",
          toString:function(){return "/_next/static/images/facebook_logo_white-25-d7634bc048e3ec1ed7e4fa40a6026fc7.png"},
          placeholder: undefined,
          width: 25,
          height: 25
      }